export const PAGE_SIZE = 12;
export const MAX_CONTENT_TRUNCATE_LENGTH = 1200;
export const MAX_CONTENT_TRUNCATE_HEIGHT = 450;

export const EXPERTS_LIST_TIMEOUT_MS = 1000;

export const MIN_EXPERTS_FOUND = 8;

export enum STATUS_CODES {
    SUCCESS = 200,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    REDIRECT = 302,
    PERMANENT_REDIRECT = 301,
    INTERNAL_ERROR = 500,
}
